module.exports = __webpack_public_path__ + "static/img/23.c61561c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ProcessAutomation/23.png
// module id = ChEC
// module chunks = 1